import { breakpoints } from '@theme/breakpoints';
import styled from 'styled-components';

export default styled.section`
  padding: 4rem 2rem;
  position: relative;
  text-align: center;

  h2 {
    font-family: var(--font-geomanist);
    font-weight: 500;
    font-size: 48px;
    line-height: 55px;
    text-align: center;
    vertical-align: middle;
  }

  @media (${breakpoints.tablet}) {
    padding: 4rem 2rem;
  }
`;
